/** @format */
import { TFunction } from 'next-i18next';

import { ModelListing } from '@toucan/client/global/model';

export const getFormattedPrice = ({
    modelListing,
    t,
}: {
    modelListing?: ModelListing;
    t: TFunction;
}) => {
    if (!modelListing) return '';

    const { quantity, priceMin, priceMax } = modelListing;

    const priceRange =
        priceMin === priceMax ? priceMin : `${priceMin}-${priceMax}`;

    const normalizedQuantity =
        quantity > 10
            ? t('10+', { context: 'moreThan10ModelsAvailable' })
            : quantity;

    const pricePrefix = t('{{quantity}} available, ', {
        quantity: normalizedQuantity,
    });

    return pricePrefix + priceRange;
};
